import useEnterprise from './use-enterprise';
import useEnterpriseConfig from './use-enterprise-config';

export { useEnterprise, useEnterpriseConfig };

export default { useEnterprise, useEnterpriseConfig };
